module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_rect_mask.58a9e1b4.png";